import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/lsa'

Styxie.Initializers.LsaSettings = {
  show: async(props) => {
    const { default: SettingsShow } = await import('@/vue_widgets/lsa/settings/index.vue')
    createVueApp(SettingsShow, { props, sidebar })
  }
}
